import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { fetchProjectExperiments } from '../api'

const useGetProjectExperimentsQuery = (projectId: string) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useQuery({
    queryKey: ['language-score', 'experiments', accountId, projectId],
    queryFn: () => fetchProjectExperiments({ projectId, accountId }),
    enabled: !!accountId && !!projectId,
  })
}

export default useGetProjectExperimentsQuery
